import React from 'react';
import { Form, Input, InputNumber, DatePicker, Switch, Select } from 'antd';
import moment from 'moment';
import {getNestedValue, setNestedValue} from "@/modules/action-flow/shared/utils/form-utils";
import {FieldConfig} from "formik";

interface FormFieldProps {
    field: FieldConfig;
    formikProps: any;
}

const FormField: React.FC<FormFieldProps> = ({ field, formikProps }) => {
    const { values, errors, touched, setFieldValue } = formikProps;
    let value: string;
    // @ts-ignore
    value = getNestedValue(values, field.key);
    // @ts-ignore
    const error = getNestedValue(errors, field.key);
    // @ts-ignore
    const isTouched = getNestedValue(touched, field.key);

    const handleChange = (newValue: any) => {
        // @ts-ignore
        setNestedValue(values, field.key, newValue);
        // @ts-ignore
        setFieldValue(field.key, newValue);
    };

    const renderField = () => {
        switch (field.type) {
            case 'text':
                // @ts-ignore
                return <Input value={value} onChange={(e) => handleChange(e.target.value)} disabled={!field.editable} />;
            case 'number':
                return (
                    <InputNumber
                        value={value}
                        onChange={handleChange}
                        // @ts-ignore
                        disabled={!field.editable}
                        style={{ width: '100%' }}
                    />
                );
            case 'date':
                return (
                    <DatePicker
                        value={value ? moment(value) : null}
                        onChange={(date) => handleChange(date ? date.format('YYYY-MM-DD') : null)}
                        // @ts-ignore
                        disabled={!field.editable}
                        style={{ width: '100%' }}
                    />
                );
            case 'boolean':
                // @ts-ignore
                return <Switch checked={value} onChange={handleChange} disabled={!field.editable} />;
            case 'select':
                return (
                    <Select
                        value={value}
                        onChange={handleChange}
                        // @ts-ignore
                        disabled={!field.editable}
                        style={{ width: '100%' }}
                    >
                        {
                            // @ts-ignore
                            field.options?.map(option => (
                            <Select.Option key={option.value} value={option.value}>
                                {option.label}
                            </Select.Option>
                        ))}
                    </Select>
                );
            default:
                // @ts-ignore
                return <Input value={value} onChange={(e) => handleChange(e.target.value)} disabled={!field.editable} />;
        }
    };

    return (
        <Form.Item
            // @ts-ignore
            label={field.label}
            validateStatus={error && isTouched ? 'error' : ''}
            help={error && isTouched ? error : undefined}
            style={{ width: '100%' }}
        >
            {renderField()}
        </Form.Item>
    );
};

export default FormField;